const colors = {
  greenishBlue: '#102C3D',
  gray: '#D9D9D9',
  darkGray: '#2C2C2C',
  lightGray: '#E7E7E7',
  lightGreen: '#DEEB52',
  textGray: '#DFE1E3',
  lemonGreen: '#E8F753',
};

export default colors;
